//Design is as for Basket Component(Mobile/Desktop)
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import Srcset from "../common/Srcset";
import styles from "../CharityComp/CharityComp.module.scss";
import PopUp from "../common/PopUp";
import SizeGuide from "../common/SizeGuide";
import CharityChangeComp from "../Basket/CharityChange";
import { useRouter } from "next/compat/router";
import { openMiniCart } from "@/redux/actions/addToCartAction";
import { handleOpeningOfAccountSidebar, openAccountSidebar, openAccountSidebarFromPwaHeader } from "@/redux/actions/loggedInUser";
import { setGlobalActiveTab, showCharityActiveMessage } from "@/redux/actions/generalAction";
import { setCookie, getCookie, deleteCookie } from "cookies-next";
import { setSidebarWidth } from "../../redux/actions/generalAction";
import { getUserCauseDetails } from "@/helpers/charityHelper";
import { isDonationProduct, isGiftCardType } from "@/helpers/pdpHelpers/priceHelpers";
import { isGuest } from "@/redux/actions/pwaAction";

export default function CharityComp(props) {
  let lineItems=props?.lineItems;
  const router = useRouter();
  const dispatch = useDispatch();
  const isUserLoggedIn = useSelector((state)=> state.loginUser.userLoggedIn);
  const cause_list = useSelector((state) => state.general.cause_list);
  const default_cause = useSelector((state) => state.general.default_cause);
  const user_cause = useSelector((state) => state.general.user_cause);
  const accountSidebarOpen = useSelector(
    (state) => state.loginUser.open_account_sidebar
  );
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  const [benefitText, setBenefitText] = useState("");
  const [causeData, setCauseData] = useState("");

  const [visibility, setVisibility] = useState(false);

  const popupCloseHandler = (e) => {
    setVisibility(e);
    dispatch(setSidebarWidth(false));
    dispatch(showCharityActiveMessage(false))
    // remove the cookie when popup is closed
    deleteCookie("openCausePopup");
  };
  useEffect(() => {
    if(cause_list?.length > 0){
      let cause = getUserCauseDetails();
      if(cause.length > 0){
        let benefitText = ''

        //We don't show the benefit unit if the hide flag is set
        if(typeof cause[0].hide_benefit != 'undefined' && cause[0].hide_benefit == 1){
          benefitText = 'Provides '+cause[0].benefit_text+' to '+cause[0].name;;
        }
        else if(props.isBag){
          let singleProductBenefitUnit=[];
          let priceNoFormat;
          let cartBenefitUnit;
          let cost_to_ship = 59
          lineItems&&lineItems.map((item)=>{
            let giftcardType = isGiftCardType(item?.node?.merchandise);
            let donationProduct = isDonationProduct(item?.node?.merchandise);
            if(!giftcardType && !donationProduct)
            {
              //assign olivela cost = 0 if olivela cost in product metafield is empty
              let olivelaCost = item?.node?.merchandise?.olivela_cost?.value;
              //Include engraving cost in metric calculation for bag when engraving is added
              let engraving_text = item?.node?.attributes?.find(attr => attr?.key === "Free engraving")?.value;
              let engraving_cost = engraving_text ? item?.node?.attributes?.find(attr => attr?.key === "_engraving_olivela_cost")?.value : 0;
              if(!olivelaCost) {
                olivelaCost = 0;
              }
              let priceV2 = item?.node?.merchandise?.priceV2?.amount;
              priceNoFormat=priceV2-(parseFloat(olivelaCost)+parseFloat(engraving_cost))-((5.5/100) * priceV2) - cost_to_ship;
              priceNoFormat = priceNoFormat * (cause[0].share_percentage/100);
              //OS-5240 if the benefit amount is going less then benefit unit then we need to make benefit amount as benefit unit
              if(priceNoFormat < cause[0].benefit_unit) {
                priceNoFormat = cause[0].benefit_unit;
              }
              let cartImpactMetric=Math.floor(((priceNoFormat))/cause[0].benefit_unit)*item?.node?.quantity;
              if(cartImpactMetric<1){
                cartImpactMetric=1;
              }
              singleProductBenefitUnit.push(cartImpactMetric);
              cartBenefitUnit=singleProductBenefitUnit.reduce((a,b)=>a+b,0);
              return cartBenefitUnit; 
            }
          })
          let pluralCauseText = cause[0]?.benefit_text;
          //We use @ in cause benefit text to replace y with ies when charity is plural.
          if(pluralCauseText?.includes("@")){
            pluralCauseText = cartBenefitUnit > 1 ? pluralCauseText.replace("y@", ""):pluralCauseText.replace("@ies", "");
          }
          if(pluralCauseText?.includes("#")) {
            pluralCauseText = cartBenefitUnit > 1 ? pluralCauseText.replace("#", ""):pluralCauseText.replace("#s", "");
          }
          benefitText = 'Provides ' +cartBenefitUnit+ ' '+pluralCauseText+' to '+cause[0].name;
        }
        else{
            let benefitUnit = ((props.price)*(cause[0].share_percentage/100))/cause[0].benefit_unit;
           if(benefitUnit < 1){
            benefitUnit= 1
           }
           let pluralCauseText = cause[0]?.benefit_text;
           //We use @ in cause benefit text to replace y with ies when charity is plural.
           if(pluralCauseText?.includes("@")){
            pluralCauseText = Math.floor(benefitUnit) > 1 ? pluralCauseText.replace("y@", ""):pluralCauseText.replace("@ies", "");
           } 
           if(pluralCauseText?.includes("#")){
            pluralCauseText = Math.floor(benefitUnit) > 1 ? pluralCauseText.replace("#", ""):pluralCauseText.replace("#s", "");
           }
           benefitText = 'Provides ' +Math.floor(benefitUnit)+ ' '+pluralCauseText+' to '+cause[0].name;
        }
        setBenefitText(benefitText)
        setCauseData(cause[0])
      }
    }
  });

  useEffect(() => {
    // OS-117/1368 If user is not logged in and the "change cause partner" link is clicked, open the account sidebar and set a cookie to remember an action to be taken if the user logs in
    // Once user is logged in, open the account sidebar and the change cause partner popup and remove the cookie
    if(isUserLoggedIn){
      const cookie = getCookie("openCausePopup");
      if(cookie) {
        const cookie_data = JSON.parse(cookie);
        if(cookie_data.value) {
          dispatch(openMiniCart(true));
          // when user logs in, at that time open the charity pop up in the side bar only
          if(props?.charityPopUpFrom === "mini-basket"){
            setVisibility(true);
          }
        }
      }

      //OS-2770 set cookie to open impact sidebar
      const impactCookie = getCookie("openImpactPopup");
      if(impactCookie) {
        const impactCookie_data = JSON.parse(impactCookie);
        if(impactCookie_data.value) {
            dispatch(setGlobalActiveTab('my-impact'));
            dispatch(openAccountSidebar(true));  
        }
        deleteCookie("openImpactPopup");
      }
    }
  }, [isUserLoggedIn, dispatch])

  useEffect(() => {
    // OS-117/1368 remove openCausePopup cookie if account sidebar is closed when not signed in
      const userdataToken = getCookie("userdataToken");
      const impactCookie = getCookie("openImpactPopup");
     
      if(!userdataToken) {
        if(!accountSidebarOpen) {
          deleteCookie("openCausePopup");
        }
      }

      if(!impactCookie) {
        if(!accountSidebarOpen) {
          deleteCookie("openImpactPopup");
        }
      }
  }, [accountSidebarOpen])

  return (
    <>
      <div className={`${styles.charity} ${props.pdpCharityComp? styles.pdp_charity_message:""}`}>
        {props?.pdpCharityComp? (
          // If the pdpCharityComp prop is true, render a clickable link to the "/impact" page
          <a href="/impact?source=pdp">
            <Srcset className="charityElem auto-charityLogo ga-impact-icon"
              height="18"
              width="18"
              requirePath={false}
              svgFile={true}
              src={causeData.benefit_logo}
              alt="Charity logo"
            />
          </a>) : (
              // If the pdpCharityComp prop is false, render a non-clickable span with the charity logo
            <span><Srcset className="charityElem auto-charityLogo"
              height="18"
              width="18"
              requirePath={false}
              svgFile={true}
              src={causeData.benefit_logo}
              alt="Charity logo"
              /></span>)}
        <span className={`${styles.charity_message} auto-charityText`}>
        <span className={`${styles.benefitText}`}>{benefitText}</span>
          {props.showChangeCausePartner && 
          <span className={`cause_partner xx-small-xs x-small-sm x-small-md ${styles.cause_partner}`}> Choose a different 
            {/* changeCausePartnerBag/changeCausePartnerPDP class added to track event in GA */}
            <span className={`${props.isBag ? "changeCausePartnerBag" : "changeCausePartnerPDP"} ${styles.cause_partner_txt}`} tabIndex={0} onClick={() => {
              //SUP-2898 : Global class "cause-sign-in" is added to hide tablet view on mobile 
              document.querySelector("body").classList.add("cause-sign-in");
              if(isUserLoggedIn) {	
                //OS-2770 : if the choose charity link is clicked from PDP
                if(props.pdpCharityComp) {	
                  dispatch(setGlobalActiveTab('my-impact'));	
                  dispatch(openAccountSidebar(true));
                  dispatch(showCharityActiveMessage(false))
                  dispatch(openAccountSidebarFromPwaHeader(false));
                }	//if the choose charity link is clicked from minibag
                else {	
                  popupCloseHandler(!visibility);	
                  dispatch(setSidebarWidth(true));
                  dispatch(showCharityActiveMessage(false))
                }         	
              }
              else {
                // OS-117/1368 If user is not logged in and the "change cause partner" link is clicked, open the account sidebar and set a cookie to remember an action to be taken if the user logs in
                dispatch(openMiniCart(false));
                //  if user using PWA and not using it for the first time then setting guest state to false
                dispatch(isGuest(false));
                dispatch(openAccountSidebar(true)); 
                // if user clicks on cause partner it should open signin drawer directly instad of account pwa drawer.
                dispatch(openAccountSidebarFromPwaHeader(false));
                // SUP-2841 : Pass a flag that indicates that account sidebar opening action is already triggered
                dispatch(handleOpeningOfAccountSidebar(true))
                //rememeber & open choose charity popup if initiated not from PDP	
                if(props.pdpCharityComp) {
                  setCookie(
                    "openImpactPopup",
                    {
                      value: true,
                    },
                    // 2 minutes age
                    { maxAge: 60 * 2 }
                  );
                }
                else {
                  setCookie(
                    "openCausePopup",
                    {
                      value: true,
                    },
                    // 2 minutes age
                    { maxAge: 60 * 2 }
                  );
                }
              }
            }}> cause partner ?</span>
          </span>}
          {props.showChangeCausePartner && 
          <div className={styles.popup_wrapper}>
            <PopUp onClose={popupCloseHandler} show={visibility} addTopSpacing={isPWA ? true : false}>
                <CharityChangeComp popupCloseHandler={popupCloseHandler}/>
                {/*  this div is added to show the charity change message otherwise overflow:hidden will hide the message */}
                {/*  i have made the visibilty none */}
                <div className={styles.optional_div}>charity change message</div>
            </PopUp>
          </div>
          }
        </span>
      </div>
    </>
  );
}
